import { render, staticRenderFns } from "./Contributors.vue?vue&type=template&id=4e8e1da4"
import script from "./Contributors.vue?vue&type=script&lang=js"
export * from "./Contributors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports